import * as React from 'react';
import customSolarIconWrapper from '../../../custom-icons';

// Placed on the shared 240x240 doodle frame: stack a body, eyes, mouth and accessory to compose a doodle
const DoodleAccessoryMoustache = customSolarIconWrapper(<g transform="translate(95 134.5)">
	<path d="M5 19.5603C15.3693 19.3793 20.943 14.5672 21.7212 5.12414" stroke="#202020" strokeWidth="10" strokeLinecap="round" />
	<path d="M23.0249 5.00104C27.4309 13.3894 34.4418 15.6411 44.0575 11.7561" stroke="#202020" strokeWidth="10" strokeLinecap="round" />
</g>, { viewBox: '0 0 240 240' });

export default DoodleAccessoryMoustache;
